import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/globals.css'
import App from './App.tsx'
import ErrorBoundary from './components/ErrorBoundary.tsx'
import { CollaborationProvider } from './components/CollaborationProvider.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <CollaborationProvider>
        <App />
      </CollaborationProvider>
    </ErrorBoundary>
  </StrictMode>,
)
